export const getUserAuth = (): string | null => {
  const auth = localStorage.getItem("auth");
  if (auth) {
    try {
      const data = JSON.parse(auth);
      const tokens = data.tokens || data.token;
      if (typeof tokens === "object" && tokens !== null) {
        return tokens.access || tokens.token || null;
      }
      return tokens || null;
    } catch {
      return null;
    }
  }
  return null;
};
